import React from 'react'
import { Translate, Localize } from 'react-i18nify';
import { TextField, InputLabel, Box } from '@mui/material';
import { CountrySelector } from '../../LanguageAndCountrySelectors';
const Address = (props) => {
    return (
        <>
        <Box sx={{ display: "felx" }} >
            <InputLabel id="Address"><Translate value="Address" /></InputLabel>
            <TextField
                sx={{ mt:1, width: "100%" }}
                id="StreetName"
                required
                onChange={(event) => {
                    props.setAddress(event.target.value);
                }}
                value={props.address}
                label={<Translate value="AddressLine" />} />
            <TextField
                sx={{ mt:1, width: "100%" }}
                id="City"
                required
                value={props.city}
                onChange={(event) => {
                    props.setCity(event.target.value);
                }}
                label={<Translate value="City" />}
            />
            
            <TextField
                sx={{ mt:1, width: "50%" }}
                id="PostalCode"
                required
                value={props.postalCode}
                onChange={(event) => {
                    props.setPostalCode(event.target.value);
                }}
                label={<Translate value="PostalCode" />}
            />
            <CountrySelector countries={props.countries} setCountry={props.setCountry} country={props.country} fromSx={{ mt: 1, width:"50%" }} />
            </Box>
        </>
    )
}


export default Address